import React, { FC, useEffect } from 'react';

import {
    PieChartOutlined,
    LineChartOutlined,
    DotChartOutlined,
    AreaChartOutlined,
    BarChartOutlined,
    QuestionCircleOutlined,
    FunnelPlotOutlined,
    DashboardOutlined
} from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

import { useActions } from '../../../shared/common/hooks/useActions';
import { useTypedSelector } from '../../../shared/common/hooks/useTypedSelector';


const ButtonsType = () => {
    const { isCompare } = useTypedSelector((state) => state.meta);
    const { chartType } = useTypedSelector((state) => state.chart);
    const { setChartType, setMetaChartFetching, setMetaCompareChartFetching } = useActions();

    const changeType = (type: string) => {

        setChartType(type);
        if (isCompare) {
            setTimeout(() => setMetaCompareChartFetching({ value: true }), 50);
        } else {
            setMetaChartFetching({ value: true });
        }
    };

    useEffect(() => {
        if (isCompare) {
            if (chartType === 'bar') {
                changeType('bar');
            } else if (chartType !== 'line') {
                changeType('line');
            }
        }
    }, [ isCompare ]);


    return (
        <Space size={7}>
            <Button
                onClick={() => changeType('pie')}
                icon={<PieChartOutlined />}
                type={chartType === 'pie' ? 'primary' : 'text'}
                title="Круговая"
                disabled={isCompare}
            />
            <Button
                onClick={() => changeType('line')}
                icon={<LineChartOutlined />}
                type={chartType === 'line' ? 'primary' : 'text'}
                title="Линии"
            />
            <Button
                onClick={() => changeType('area')}
                icon={<AreaChartOutlined />}
                type={chartType === 'area' ? 'primary' : 'text'}
                title="Области"
                disabled={isCompare}
            />
            <Button
                onClick={() => changeType('bar')}
                icon={<BarChartOutlined />}
                type={chartType === 'bar' ? 'primary' : 'text'}
                title="Колонки"
            />
            <Button
                onClick={() => changeType('bubble')}
                icon={<DotChartOutlined />}
                type={chartType === 'bubble' ? 'primary' : 'text'}
                title="Пузырьковая"
                disabled={isCompare}
            />
            <Button
                onClick={() => changeType('tunnel')}
                icon={<FunnelPlotOutlined />}
                type={chartType === 'tunnel' ? 'primary' : 'text'}
                title="Тунельная "
                disabled={isCompare}
            />
            <Button
                onClick={() => changeType('speedometer')}  // Можно изменить тип на "speedometer" или другой
                icon={<DashboardOutlined />}  // Иконка для спидометра
                type={chartType === 'speedometer' ? 'primary' : 'text'}
                title="Выберите метрику с указанным планом"
                disabled={isCompare}
            />
        </Space>
    );
};

export default ButtonsType;